export interface Municipality {
    id: number;
    name: string;
    stateId?: number;
}
